import React from 'react';

import type { ProductConfig, ProductKeys1P } from '../../../common/constants/products';
import { FilterButton } from '../../../common/ui/quick-find/filter-button';

import type { OnAppFilterSelectedCallback } from './filters-row-types';

export const AppButton1P = ({
	productConfig,
	onAppFilterSelected,
	productKey,
}: {
	productConfig: ProductConfig;
	onAppFilterSelected: OnAppFilterSelectedCallback;
	productKey: ProductKeys1P;
}) => {
	const Icon = productConfig.IconBorderless ?? productConfig.Icon;

	return (
		<FilterButton
			iconBefore={<Icon size={'xsmall'} />}
			contentFit={'default'}
			isSelected={false}
			spacing={'default'}
			onClick={(event) => {
				onAppFilterSelected(
					productKey,
					{
						redirectToFPS: true,
						isPostAuthAction: false,
					},
					event,
				);
			}}
		>
			{productConfig.displayName}
		</FilterButton>
	);
};
